module.exports = __webpack_public_path__ + "static/media/japan09.88a63faf.jpg";